/**
 * @name objectEntries
 * @summary A version of Object.entries that is typed for TS
 */
export function objectEntries(obj) {
    return Object.entries(obj);
}
